import { all } from 'redux-saga/effects';

import watchAuthActions from './watchFunctions/watchAuthActions';
import watchHomeActions from './watchFunctions/watchHomeActions';
import watchNotificationActions from './watchFunctions/watchNotificationActions';
import watchOrganisationActions from './watchFunctions/watchOrganisationActions';
import watchPreregisteredDevicesUploadActions from './watchFunctions/watchPreregisteredDevicesUploadActions';
import watchReportsAction from './watchFunctions/watchReportsActions';
import watchSdCardUploadAction from './watchFunctions/watchSdCardUploadActions';
import watchSettingActions from './watchFunctions/watchSettingActions';
import watchTenantActions from './watchFunctions/watchTenantActions';
import watchTrustedBrowserActions from './watchFunctions/watchTrustedBrowserActions';
import watchUnhandledExceptionActions from './watchFunctions/watchUnhandledExceptionActions';
import watchUserActions from './watchFunctions/watchUserActions';

export default function* rootSaga() {
  yield all([
    watchNotificationActions(),
    watchUnhandledExceptionActions(),
    watchAuthActions(),
    watchUserActions(),
    watchOrganisationActions(),
    watchSettingActions(),
    watchTenantActions(),
    watchTrustedBrowserActions(),
    watchHomeActions(),
    watchReportsAction(),
    watchSdCardUploadAction(),
    watchPreregisteredDevicesUploadActions(),
  ]);
}
